import { createSlice } from "@reduxjs/toolkit";
import { apiAxios } from "../../utils/axios";

const initialState = {
  tab: "home",
  isLoading: false,
  isLoadingGetUser: false,
  isLoadingGetDataOptions: false,
  isLoadingUpdateStatus: false,
  isLoadingUpdateOptionStatusForm: false,
  isLoadingUpdateStatusDetect: false,
  isLoadingAddUser: false,
  isLoadingAddDataOptions: false,
  isLoadingDeleteUser: false,
  isLoadingUpdateUserData: false,
  isLoadingDetect: false,
  isLoadingViolationCodeInter: false,
  isLoadingViolationTypeInter: false,
  isLoadingViolationCodeMongo: false,
  isLoadingViolationTypeMongo: false,
  isLoadingViolation: false,
  isLoadingViolationStatus: false,
  isLoadingViolationMongo: false,
  isLoadingViolationCodeInterDetect: false,
  isLoadingViolationTypeInterDetect: false,
  isLoadingViolationCodeMongoDetect: false,
  isLoadingViolationTypeMongoDetect: false,
  isLoadingViolationDetect: false,
  isLoadingViolationMongoDetect: false,
  isLoadingUpdateStatusReport: false,
  isLoadingViolationMongoReport: false,
  isLoadingUpdateReviewerName: false,
  isLoadingUpdateReviewerReportName: false,
  error: null,
  success: false,
  status: "",
  statusDetect: false,
  statusViolation: false,
  statusViolationDetect: false,
  statusDataOptions: false,
  data: [],
  dataOptions: [],
  dataCheck: [],
  users: [],
  dataDetect: {},
  violationCode: [],
  violationTypes: [],
  pdfUrl: "",
  pdfUrlLaos: "",

};

const slice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateTab(state, action) {
      state.tab = action.payload;
    },
    getAllData(state, action) {
      state.isLoading = action.payload.isLoading;
      state.error = action.payload.error;
      state.data = action.payload.data;
    },
    getDataCheck(state, action) {
      state.isLoading = action.payload.isLoading;
      state.error = action.payload.error;
      state.dataCheck = action.payload.dataCheck;
    },
    getAllUsers(state, action) {
      state.isLoadingGetUser = action.payload.isLoadingGetUser;
      state.error = action.payload.error;
      state.users = action.payload.users;
    },
    getDataOptions(state, action) {
      state.isLoadingGetDataOptions = action.payload.isLoadingGetDataOptions;
      state.error = action.payload.error;
      state.dataOptions = action.payload.dataOptions;
    },
    updateOptionStatus(state, action) {
      state.isLoadingUpdateOptionStatusForm = action.payload.isLoadingUpdateOptionStatusForm;
      state.error = action.payload.error;
      state.statusDataOptions = action.payload.statusDataOptions;
    },
    updateStatus(state, action) {
      state.isLoadingUpdateStatus = action.payload.isLoadingUpdateStatus;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateStatusDetect(state, action) {
      state.isLoadingUpdateStatusDetect =
      action.payload.isLoadingUpdateStatusDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    addUser(state, action) {
      state.isLoadingAddUser = action.payload.isLoadingAddUser;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    addDataOptions(state, action) {
      state.isLoadingAddDataOptions = action.payload.isLoadingAddDataOptions;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    updateUser(state, action) {
      state.isLoadingUpdateUserData = action.payload.isLoadingUpdateUserData;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    deleteUser(state, action) {
      state.isLoadingDeleteUser = action.payload.isLoadingDeleteUser;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    detectImg(state, action) {
      state.isLoadingDetect = action.payload.isLoadingDetect;
      state.error = action.payload.error;
      state.statusDetect = action.payload.statusDetect;
      state.dataDetect = action.payload.dataDetect;
    },
    detectUrl(state, action) {
      state.isLoadingDetect = action.payload.isLoadingDetect;
      state.error = action.payload.error;
      state.status = action.payload.status;
      state.dataDetect = action.payload.dataDetect;
    },
    updateViolationCodeInter(state, action) {
      state.isLoadingViolationCodeInter =
        action.payload.isLoadingViolationCodeInter;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationTypeInter(state, action) {
      state.isLoadingViolationTypeInter =
        action.payload.isLoadingViolationTypeInter;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationCodeMongo(state, action) {
      state.isLoadingViolationCodeMongo =
        action.payload.isLoadingViolationCodeMongo;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationTypeMongo(state, action) {
      state.isLoadingViolationTypeMongo =
        action.payload.isLoadingViolationTypeMongo;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolation(state, action) {
      state.isLoadingViolation = action.payload.isLoadingViolation;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationStatus(state, action) {
      state.isLoadingViolationStatus = action.payload.isLoadingViolationStatus;
      state.error = action.payload.error;
      state.statusDataOptions = action.payload.statusDataOptions;
    },
    updateViolationMongo(state, action) {
      state.isLoadingViolationMongo = action.payload.isLoadingViolationMongo;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationCodeInterDetect(state, action) {
      state.isLoadingViolationCodeInterDetect =
        action.payload.isLoadingViolationCodeInterDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationTypeInterDetect(state, action) {
      state.isLoadingViolationTypeInterDetect =
        action.payload.isLoadingViolationTypeInterDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationCodeMongoDetect(state, action) {
      state.isLoadingViolationCodeMongoDetect =
        action.payload.isLoadingViolationCodeMongoDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationTypeMongoDetect(state, action) {
      state.isLoadingViolationTypeMongoDetect =
        action.payload.isLoadingViolationTypeMongoDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationDetect(state, action) {
      state.isLoadingViolationDetect = action.payload.isLoadingViolationDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationMongoDetect(state, action) {
      state.isLoadingViolationMongoDetect =
        action.payload.isLoadingViolationMongoDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationReport(state, action) {
      state.isLoadingViolationReport = action.payload.isLoadingViolationReport;
      state.error = action.payload.error;
      state.statusDataOptions = action.payload.statusDataOptions;
    },
    updateStatusReport(state, action) {
      state.isLoadingUpdateStatusReport = action.payload.isLoadingUpdateStatusReport;
      state.error = action.payload.error;
      state.statusDataOptions = action.payload.statusDataOptions;
    },
    updateViolationMongoReport(state, action) {
      state.isLoadingViolationMongoReport = action.payload.isLoadingViolationMongoReport;
      state.error = action.payload.error;
      state.statusDataOptions = action.payload.statusDataOptions;
    },
    uploadLawInternational(state, action) {
      state.pdfUrl = action.payload.pdfUrl;
      state.error = action.payload.error;
    },
    uploadLawMongo(state, action) {
      state.pdfUrlMongo = action.payload.pdfUrlMongo;
      state.error = action.payload.error;
    },
    updateReviewerName: (state, action) => {
      state.isLoadingUpdateReviewerName = action.payload.isLoadingUpdateReviewerName;
      if (action.payload.success !== undefined) {
        state.updateReviewerNameSuccess = action.payload.success;
      }
      if (action.payload.error) {
        state.updateReviewerNameError = action.payload.error;
      }
      if (action.payload.message) {
        state.updateReviewerNameMessage = action.payload.message;
      }
    },
    updateReviewerNameReport: (state, action) => {
      state.isLoadingUpdateReviewerNameReport = action.payload.isLoadingUpdateReviewerNameReport;
      if (action.payload.success !== undefined) {
        state.updateReviewerNameSuccess = action.payload.success;
      }
      if (action.payload.error) {
        state.updateReviewerNameError = action.payload.error;
      }
      if (action.payload.message) {
        state.updateReviewerNameMessage = action.payload.message;
      }
    },
  },
});

// Reducer
export default slice.reducer;

export function updateTab(tab) {
  return async (dispatch) => {
    dispatch(slice.actions.updateTab(tab));
  };
}


// addDataOptions
export function addDataOptions(formValues) {
  return async (dispatch) => {

    dispatch(slice.actions.addDataOptions({ isLoadingAddDataOptions: true }));

    try {
      const response = await apiAxios.post(
        "/add_data_options",
        formValues,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setTimeout(() => {
        dispatch(
          slice.actions.addDataOptions({
            isLoadingAddDataOptions: false,
            status: response.data.status,
          })
        );
      }, 2000);

    } catch (error) {
      setTimeout(() => {
        dispatch(
          slice.actions.addDataOptions({
            isLoadingAddDataOptions: false,
            error: error.message || "Unknown error occurred",
          })
        );
      }, 2000);
    }
  };
}

export function getDataOptions() {
  return async (dispatch) => {
    dispatch(slice.actions.getDataOptions({ isLoadingGetDataOptions: true }));
    await apiAxios
      .get(
        "/get_data_options",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getDataOptions({
            isLoadingGetDataOptions: false,
            dataOptions: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getDataOptions({
            isLoadingGetDataOptions: false,
            error: error.message,
          })
        );
      });
  };
}

export function getAllData() {
  return async (dispatch) => {
    dispatch(slice.actions.getAllData({ isLoading: true }));
    await apiAxios
      .get("/get_data", {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then(function (response) {
        dispatch(
          slice.actions.getAllData({ isLoading: false, data: response.data })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getAllData({ isLoading: false, error: error.message })
        );
      });
  };
}

export function getDataCheck() {
  return async (dispatch) => {
    dispatch(slice.actions.getDataCheck({ isLoading: true }));
    await apiAxios
      .get(
        "/get_user_check_argentina_data",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getDataCheck({
            isLoading: false,
            dataCheck: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getDataCheck({ isLoading: false, error: error.message })
        );
      });
  };
}

export function updateViolationReport(_id, violation) {
  return async (dispatch) => {
    dispatch(slice.actions.updateViolationReport({ isLoadingViolationReport: true }));

    await apiAxios
      .post(
        `/update_violation_report`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationReport({
              isLoadingViolationReport: false,
              statusDataOptions: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationReport({
            isLoadingViolationReport: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateStatusReport(_id, status, isPublic) {
  return async (dispatch) => {
    dispatch(slice.actions.updateStatusReport({ isLoadingUpdateStatusReport: true }));

    await apiAxios
      .put(
        `/update_status_report`,
        { _id, status, isPublic },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatusReport({
              isLoadingUpdateStatusReport: false,
              statusDataOptions: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateStatusReport({ isLoading: false, error: error.message })
        );
      });
  };
}

export function updateOptionStatus(_id, optionStatus) {
  return async (dispatch) => {
    // Bắt đầu cập nhật trạng thái
    dispatch(slice.actions.updateOptionStatus({ isLoadingUpdateOptionStatusForm: true }));

    try {
      // Gửi yêu cầu PUT
      const response = await apiAxios.put(
        `/update_option_status`,
        { _id, optionStatus },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Cập nhật trạng thái sau khi nhận được phản hồi
      dispatch(
        slice.actions.updateOptionStatus({
          isLoadingUpdateOptionStatusForm: false,
          statusDataOptions: response.data.success,
          error: null, // Đặt error thành null nếu không có lỗi
        })
      );

    } catch (error) {
      // Xử lý lỗi
      dispatch(
        slice.actions.updateOptionStatus({
          isLoadingUpdateOptionStatusForm: false,
          error: error.message,
        })
      );
    }
  };
}


export function updateStatus(_id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.updateStatus({ isLoadingUpdateStatus: true }));

    await apiAxios
      .put(
        `/update_status`,
        { _id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatus({
              isLoadingUpdateStatus: false,
              statusViolation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateStatus({ isLoading: false, error: error.message })
        );
      });
  };
}

export function updateStatusDetect(_id, status) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateStatusDetect({ isLoadingUpdateStatusDetect: true })
    );

    await apiAxios
      .put(
        `/update_status_detect`,
        { _id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatusDetect({
              isLoadingUpdateStatusDetect: false,
              statusViolationDetect: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateStatusDetect({
            isLoadingUpdateStatusDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function getAllUsers() {
  return async (dispatch) => {
    dispatch(slice.actions.getAllData({ isLoadingGetUser: true }));
    await apiAxios
      .get(
        "/get_users",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getAllUsers({
            isLoadingGetUser: false,
            users: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getAllUsers({
            isLoadingGetUser: false,
            error: error.message,
          })
        );
      });
  };
}

export function addUser(formValues) {
  return async (dispatch) => {
    dispatch(slice.actions.addUser({ isLoadingAddUser: true }));
    await apiAxios
      .post(
        "/add_user",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.addUser({
              isLoadingAddUser: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        setTimeout(() => {
          dispatch(
            slice.actions.addUser({
              isLoadingAddUser: false,
              error: error.message,
            })
          );
        }, 2000);
      });
  };
}

export function updateUser(formValues) {
  return async (dispatch) => {
    dispatch(slice.actions.updateUser({ isLoadingUpdateUserData: true }));
    await apiAxios
      .put(
        "/update_user",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateUser({
              isLoadingUpdateUserData: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.addUser({
            isLoadingUpdateUserData: false,
            error: error.message,
          })
        );
      });
  };
}

export function deleteUser(data) {
  return async (dispatch) => {
    dispatch(slice.actions.deleteUser({ isLoadingDeleteUser: true }));
    await apiAxios
      .delete(
        "/delete_user",
        {
          data: {
            id: data,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.deleteUser({
              isLoadingDeleteUser: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        setTimeout(() => {
          dispatch(
            slice.actions.deleteUser({
              isLoadingDeleteUser: false,
              error: error.message,
            })
          );
        }, 2000);
      });
  };
}

export function detectImg(formData) {
  return async (dispatch) => {
    dispatch(slice.actions.detectImg({ isLoadingDetect: true }));
    await apiAxios
      .post(
        "/api/check-violation-argentina-user-check-text-imgs",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.detectImg({
            isLoadingDetect: false,
            dataDetect: response.data,
            statusDetect: response.data.status,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.detectImg({
            isLoadingDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function detectUrl(url, desc) {
  return async (dispatch) => {
    dispatch(slice.actions.detectImg({ isLoadingDetect: true }));
    await apiAxios
      .post(
        "/api/check-violation-argentina-user-check-url",
        { url, desc },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.detectUrl({
            isLoadingDetect: false,
            dataDetect: response.data,
            statusDetect: response.data.status,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.detectUrl({
            isLoadingDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationMongoReport(_id, violation) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationMongoReport({ isLoadingViolationMongoReport: true })
    );

    await apiAxios
      .post(
        `/update_mongo_violation_report`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationMongoReport({
              isLoadingViolationMongoReport: false,
              statusDataOptions: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationMongoReport({
            isLoading: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeInter(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeInter({
        isLoadingViolationCodeInter: true,
      })
    );
    await apiAxios
      .post(
        "/update_violation_code",
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeInter({
              isLoadingViolationCodeInter: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeInter({
            isLoadingViolationCodeInter: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeInter(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeInter({
        isLoadingViolationTypeInter: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await apiAxios
      .post(
        "/update_violation_type",
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeInter({
              isLoadingViolationTypeInter: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeInter({
            isLoadingViolationTypeInter: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeMongo(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeMongo({
        isLoadingViolationCodeMongo: true,
      })
    );
    await apiAxios
      .post(
        "/update_mongo_violation_code",
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeMongo({
              isLoadingViolationCodeMongo: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeMongo({
            isLoadingViolationCodeMongo: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeMongo(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeMongo({
        isLoadingViolationTypeMongo: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await apiAxios
      .post(
        "/update_mongo_violation_type",
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeMongo({
              isLoadingViolationTypeMongo: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeMongo({
            isLoadingViolationTypeMongo: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolation(_id, violation) {
  return async (dispatch) => {
    dispatch(slice.actions.updateViolation({ isLoadingViolation: true }));

    await apiAxios
      .post(
        `/update_violation`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolation({
              isLoadingViolation: false,
              statusViolation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolation({
            isLoading: false,
            error: error.message,
          })
        );
      });
  };
}
export function updateViolationStatus(_id, violation) {
  return async (dispatch) => {
    dispatch(slice.actions.updateViolationStatus({ isLoadingViolationStatus: true }));

    await apiAxios
      .post(
        `/update_violation_status`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationStatus({
              isLoadingViolationStatus: false,
              statusDataOptions: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationStatus({
            isLoadingViolationStatus: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationMongo(_id, violation) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationMongo({ isLoadingViolationMongo: true })
    );

    await apiAxios
      .post(
        `/update_mongo_violation`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationMongo({
              isLoadingViolationMongo: false,
              statusViolation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationMongo({
            isLoading: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeInterDetect(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeInterDetect({
        isLoadingViolationCodeInterDetect: true,
      })
    );
    await apiAxios
      .post(
        "/update_violation_code_detect",
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeInterDetect({
              isLoadingViolationCodeInterDetect: false,
              statusViolationDetect: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeInterDetect({
            isLoadingViolationCodeInterDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeInterDetect(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeInterDetect({
        isLoadingViolationTypeInterDetect: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await apiAxios
      .post(
        "/update_violation_type_detect",
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeInterDetect({
              isLoadingViolationTypeInterDetect: false,
              statusViolationDetect: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeInterDetect({
            isLoadingViolationTypeInterDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeMongoDetect(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeMongoDetect({
        isLoadingViolationCodeMongoDetect: true,
      })
    );
    await apiAxios
      .post(
        "/update_mongo_violation_code_detect",
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeMongoDetect({
              isLoadingViolationCodeMongoDetect: false,
              statusViolationDetect: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeMongoDetect({
            isLoadingViolationCodeMongoDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeMongoDetect(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeMongoDetect({
        isLoadingViolationTypeMongoDetect: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await apiAxios
      .post(
        "/update_mongo_violation_type_detect",
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeMongoDetect({
              isLoadingViolationTypeMongoDetect: false,
              statusViolationDetect: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeMongoDetect({
            isLoadingViolationTypeMongoDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationDetect(_id, violation) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationDetect({ isLoadingViolationDetect: true })
    );

    await apiAxios
      .put(
        `/update_violation_detect`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationDetect({
              isLoadingViolationDetect: false,
              statusViolationDetect: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationDetect({
            isLoadingViolationDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationMongoDetect(_id, violation) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationMongoDetect({
        isLoadingViolationMongoDetect: true,
      })
    );

    await apiAxios
      .put(
        `/update_mongo_violation_detect`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationMongoDetect({
              isLoadingViolationMongoDetect: false,
              statusViolationDetect: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationMongoDetect({
            isLoadingViolationMongoDetect: false,
            error: error.message,
          })
        );
      });
  };
}


export function uploadLawInternational(formData) {
  return async (dispatch) => {
    await apiAxios
      .put(
        "/upload_file_international",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.uploadLawInternational({
            pdfUrl: response.data.url,
            error: null,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.uploadLawInternational({
            error: error.message,
          })
        );
      });
  };
}

export function uploadLawMongo(formData) {
  return async (dispatch) => {
    await apiAxios
      .put(
        "/upload_file_mongo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.uploadLawMongo({
            pdfUrlLaos: response.data.url,
            error: null,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.uploadLawMongo({
            error: error.message,
          })
        );
      });
  };
}
export function updateReviewerNameReport(data) {
  return async (dispatch) => {
    dispatch(slice.actions.updateReviewerNameReport({ isLoadingUpdateReviewerNameReport: true }));
    
    await apiAxios
      .post(
        "/update_reviewer_name_report",
        {
          id: data.id,
          reviewer_name: data.reviewer_name
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        dispatch(
          slice.actions.updateReviewerNameReport({
            isLoadingUpdateReviewerNameReport: false,
            success: true,
            message: response.data.message || "Reviewer name updated successfully"
          })
        );
      })
      .catch(function (error) {
        console.error("Error updating reviewer name:", error);
        dispatch(
          slice.actions.updateReviewerNameReport({
            isLoadingUpdateReviewerNameReport: false,
            success: false,
            error: error.message,
          })
        );
      });
  };
}


export function updateReviewerName(data) {
  return async (dispatch) => {
    dispatch(slice.actions.updateReviewerName({ isLoadingUpdateReviewerName: true }));
    
    await apiAxios
      .post(
        "/update_reviewer_name",
        {
          id: data.id,
          reviewer_name: data.reviewer_name
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        dispatch(
          slice.actions.updateReviewerName({
            isLoadingUpdateReviewerName: false,
            success: true,
            message: response.data.message || "Reviewer name updated successfully"
          })
        );
      })
      .catch(function (error) {
        console.error("Error updating reviewer name:", error);
        dispatch(
          slice.actions.updateReviewerName({
            isLoadingUpdateReviewerName: false,
            success: false,
            error: error.message,
          })
        );
      });
  };
}